import type { ParseKeys } from "i18next";
import { English } from "./locales/en";
import { Norwegian } from "./locales/nb";

export const Language = {
	Norwegian: "nb",
	English: "en",
} as const;
export type Language = (typeof Language)[keyof typeof Language];

const en = {
	COMMON: English.Utility.Common,
	SETTINGS: English.Pages.Settings,
	ERROR: English.Utility.Error,
	FORMAT: English.Utility.Format,
	HOME: English.Pages.Home,
	DATA_TYPES: English.Utility.DataTypes,
} as const;

export type TranslationTemplate = typeof en;

export const TRANSLATION_KEYS = Object.keys(en).reduce(
	(acc, key) => {
		acc[key as keyof TranslationTemplate] = key as keyof TranslationTemplate;
		return acc;
	},
	{} as Record<keyof TranslationTemplate, keyof TranslationTemplate>,
);

const nb: TranslationTemplate = {
	COMMON: Norwegian.Utility.Common,
	SETTINGS: Norwegian.Pages.Settings,
	ERROR: Norwegian.Utility.Error,
	FORMAT: Norwegian.Utility.Format,
	HOME: Norwegian.Pages.Home,
	DATA_TYPES: Norwegian.Utility.DataTypes,
} as const;

export const resources = {
	[Language.Norwegian]: nb,
	[Language.English]: en,
} as const;

export type NS = keyof TranslationTemplate;

export type DefaultNS = NS[];

export type LocalizedLabelKey =
	| ParseKeys<NS, Record<string, never>, DefaultNS>
	| TemplateStringsArray;

declare module "i18next" {
	interface CustomTypeOptions {
		defaultNS: NS[];
		resources: TranslationTemplate;
	}
}
